/*
 *in this module there are all the functions that handle the fra staff buttons in the popup
 */

/**
 * import modules
 */

import fralayers from './fralayers'

/**
 * initialize the dummy parameter to update the layer
 * has to be global has we call those functions each time we create a popup
 * doing so we reset all the time the var if it's inside
 */

let iDelRef = 0

/**
 * edit the action field
 */

function editActionField () {
  $('.edit-action').on('click', () => {
    /**
     * get the id of the .edit-action button and split it by __
     * from that get and save the:
     *  - fref
     *  - tempstamp
     *  - tstamp
     *  - tstamptime
     *  - faction
     */

    const temp = $('.edit-action').attr('id').split('__')
    const fref = temp[0]
    const tempstam = temp[2].split(',')
    const tstamp = tempstam[0]
    const tstamptime = tempstam[1]
    let fstatus = $('.togle input[name=radio]:checked').parent().parent().val()
    let faction = temp[3]

    /**
     * show editdiv
     */

    $('.editdiv').show()

    /**
     * check which popup is in use
     * append the $('.action').text() to the correct textarea
     */

    if ($('#mobpopup').hasClass('show')) {
      $('.editdivm textarea').val($('.action').text())
    }
    else {
      $('.editdivp textarea').val($('.action').text())
    }

    /**
     * .editCancel click handler
     * check which popup is in use
     * change the val of the correct textarea
     * hide the editdiv
     */

    $('.editCancel').on('click', function () {
      if ($('#mobpopup').hasClass('show')) {
        $('.editdivm textarea').val('')
      }
      else {
        $('.editdivp textarea').val('')
      }
      $('.editdiv').hide()
    })

    /**
     * .save click event handler
     */

    $('.editSave').on('click', () => {
      /**
       * .save click event handler
       * check which popup is in use
       * change the faction var with the value of the correct textarea
       */

      if ($('#mobpopup').hasClass('show')) {
        faction = $('.editdivm textarea').val()
      }
      else {
        faction = $('.editdivp textarea').val()
      }

      /**
       * check if faction is empty
       * change the text of .action accordingly
       */

      if (faction === '') {
        $('.action').html('')
      }
      else {
        $('.action').html(faction)
      }

      /**
       * change the value of temp[3] with the new text
       * update the ID of the .edit-action button
       */

      temp[3] = faction

      $('.edit-action').attr('id', temp.join('__'))

      /**
       * check if it's a localhost environment
       * set the correct path to the php file
       */

   /**
     * create the json data
     */

    let theData = '{"fref": "' + fref + '", "stamp": "' + tstamp + ' ' + tstamptime + '", "action": "' + faction + '", "status": "' + fstatus + '"}'

    /**
     * send an ajax reuqest
     */
    $('.loading').show()
    $.ajax({
     url: '/traffweb/fra-update',
     type:"POST",
     data: {
       jdata: theData
     },
     beforeSend: function beforeSend(xhr) {
       xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
     }
    })
      .done(() => {
        /**
         * parse the result if is the dev server with webpack
         */
        iDelRef += 1
        fralayers.updateLayerParams($('#frapsafeatclick').val(), iDelRef)

      }) // end done
      .fail(function (jqxhr, textStatus, error) {
        const err = `${textStatus}, ${error}`
        alert(`THEURLS Request Failed: ${err}`)
      })
      .always(() => {
        /**
         * hide the loading bar
         */

        $('.loading').hide()
      })
      /**
       * hide the .editdiv
       */

      $('.editdiv').hide()

      /**
       * end $('.editSave').on('click', () => {
       * end $('.edit-action').on('click', () => {
       * end editActionField ()
       */
    })
  })
}

/**
 * delete the fault
 */

function fraDeleteItem (overlay) {
  $('.fraDelete').on('click', function () {
    /**
     * get the id of the .edit-action button and split it by _
     * from that get and save the:
     *  - tempstamp
     *  - tstamp
     *  - tstamptime
     *  - fref
     */

    let temp = this.id.split('_')
    let tempstam = temp[1].split(',')
    var tmpDate = tempstam[0].split('-')
    const tstamp = tmpDate[2] + '/' + tmpDate[1] + '/' + tmpDate[0]
    const tstamptime = tempstam[1]
    const fref = temp[0]

    /**
     * display the modal for confirmation
     * populate the .deleteorder with the fref var
     */

    $('#delconf').modal('show')
    $('.deleteorder').html(fref)

    /**
     * hide the mobile popup if it's visible
     */

    if ($('#mobpopup').hasClass('show')) {
      $('#mobpopup').modal('hide')
    }

    /**
     * .okCancel click handler
     */

    $('.okCancel').on('click', function () {
      /**
       * hide the confirmation modal
       * send a post request and delete the fault
       */

      $('#delconf').modal('hide')

      /**
       * create the json data
       */

      let theData = '{"fref": "' + fref + '", "stamp": "' + tstamp + ' ' + tstamptime + '"}'

      /**
       * Ajax request
       */
      $('.loading').show()
      $.ajax({
        url: '/traffweb/fra-delete',
        type:"POST",
        data: {
          jdata: theData
        },
        beforeSend: function beforeSend(xhr) {
          xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
        }
      })
      .done((result) => {
        iDelRef += 1
        fralayers.updateLayerParams($('#frapsafeatclick').val(), iDelRef)
      })
      .always(() => {
        /**
         * hide the loading bar
         */

        $('.loading').hide()
      })
      /**
       * reset the .deleteorder text
       * hide the popup and the mobile popup
       */

      $('.deleteorder').html('')

      overlay.setPosition(undefined)
      $('#mobpopup').modal('hide')
    })

    /**
     * .deleteCancel click handler
     */

    $('.deleteCancel').on('click', function () {
      /**
       * hide the confirmation modal
       * reset the .deleteorder text
       */

      $('#delconf').modal('hide')
      $('.deleteorder').html('')
    })

    /**
     * end $('.fraDelete').on('click', function () {
     * end function fraDeleteItem () {
     */
  })
}

/**
 * update the fault status
 */

function fraUpdateStatus () {
  $('.fraSave').on('click', function () {
    /**
     * get the id of the .edit-action button and split it by _
     * from that get and save the:
     *  - fref
     *  - tempstamp
     *  - tstamp
     *  - tstamptime
     * get the .action text
     * get the status from the checked radio button
     */

    let temp = this.id.split('_')
    let fref = temp[0]
    let tempstam = temp[2].split(',')
    const tstamp = tempstam[0]
    const tstamptime = tempstam[1]
    let faction = $('.action').text()
    let fstatus = $('.togle input[name=radio]:checked').val()

    /**
     * create the json data
     */

    let theData = '{"fref": "' + fref + '", "stamp": "' + tstamp + ' ' + tstamptime + '", "action": "' + faction + '", "status": "' + fstatus + '"}'

    /**
     * Ajax request
     */
    $('.loading').show()
    $.ajax({
      url: '/traffweb/fra-update',
      type:"POST",
      data: {
        jdata: theData
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
      }
    })
    .done((result) => {
      iDelRef += 1
      fralayers.updateLayerParams($('#frapsafeatclick').val(), iDelRef)
    })
    .always(() => {
      /**
       * hide the loading bar
       */

      $('.loading').hide()
    })
    /**
     * end function fraUpdateStatus () {
     * end $('.fraSave').on('click', function () {
     */
  })
}

/**
 * EXPORT
 */

export default {
  editActionField,
  fraDeleteItem,
  fraUpdateStatus
}
